Vue.component('ack-product-carousel-cart', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-product-carousel-cart',
	mounted() {},
	props: {
		productCartItems: {
			// :product-info
			type: Array,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		...Vuex.mapGetters('shop', ['productList']),
		...Vuex.mapGetters('shop', ['isStoreAvailable']),
		...Vuex.mapGetters('localization', ['countryCode']),

		productWithAvailability() {
			return this.productCartItems.map((m) => {
				let item = m;

				if (item.onlyIfStoreAvailable == true) {
					if (this.isStoreAvailable) {
						item.isAvailable = true;
					} else {
						item.isAvailable = false;
					}
				} else if (item.onlyifUSorCA == true) {
					if (this.isStoreAvailable) {
						item.isAvailable = false;
					} else {
						item.isAvailable = true;
					}
				} else {
					item.isAvailable = true;
				}

				return item;
			});
		},

		carouselOptions() {
			let opt = {
				arrows: true,
				dots: false,
				infinite: false,
				slidesToShow: this.isMobile ? 1 : 4,
				slidesToScroll: 1,
				autoplay: false,
				speed: 500,
				autoplaySpeed: 0,
				cssEase: 'linear',
				initialSlide: -1,
			};

			return opt;
		},
	},
	data() {
		return {};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		...Vuex.mapActions('shop', ['sayHi', 'closeAllMobileDropdowns', 'addToCartFromProperties']),

		showProductPageLink(product) {
			const pageUrl = product.page_url || '';
			const isTaiwan = this.countryCode && this.countryCode.toUpperCase() === 'TW';

			return pageUrl && pageUrl !== '#' && !(isTaiwan && pageUrl.startsWith('/products/'));
		},

		isPurchaseTemporarilyDisabled(product) {
			return isProductPurchaseTemporarilyDisabled(product.shopifyId);
		},

		onAddToCartClick({ shopifyId, variantId, sellingPlanId }) {
			appLog.log('onAddToCartClick', LOG_TYPE.debug);
			appLog.log({ shopifyId, variantId, sellingPlanId }, LOG_TYPE.debug);

			this.addToCartFromProperties({ productId: shopifyId, variantId, sellingPlanId });
		},
	},
	beforeDestroy() {},
	watch: {
		prop1: {
			handler() {},
			deep: false,
		},
	},
});
